import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import ProjectsPage from "@/pages/projects/components/ProjectsPage";

const searchSchema = z.object({
  addProjectSources: z.coerce.boolean().optional(),
});

export const Route = createFileRoute("/_secure/_main/projects")({
  validateSearch: zodValidator(searchSchema),
  component: RouteComponent,
});

function RouteComponent() {
  return <ProjectsPage />;
}
